import { useMemo, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AppState, AppDispatch } from '@/store/types'
import { CoinBasis, WalletCoin } from '@/services/apis/coin/models'
import { getBasicCoinList } from '@/store/wallet'
import coinApi from '@/services/apis/coin'
import emitter from '@/utils/event'
import { REFRESH_WALLET_DETAIL_EVENT } from '@/constants/event'

export const useCoinBasis = (coinKey?: string) => {
  const coinList = useSelector<AppState, CoinBasis[]>(state => state.wallet.basicCoinList)
  const dispatch = useDispatch<AppDispatch>()
  useEffect(() => {
    if (!coinList.length) {
      dispatch(getBasicCoinList())
    }
  }, [])
  return useMemo(() => coinList.find(coin => coin.coinKey === coinKey), [coinList, coinKey])
}

export const useGetWalletCoinList = (walletKey: string) => {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<WalletCoin[]>([])
  useEffect(() => {
    setIsLoading(true)
    coinApi
      .getVaultCoinList({ accountKey: walletKey })
      .then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
      .finally(() => setIsLoading(false))
  }, [])
  return {
    data,
    isLoading,
  }
}

export const useSearchWalletCoinList = (searchValue: string, list: WalletCoin[]): WalletCoin[] => {
  return useMemo(() => {
    return searchValue
      ? list?.filter(coin => coin.coinName.toLowerCase().includes(searchValue.toLowerCase()))
      : list
  }, [list, searchValue])
}

export const useChangeCoinSwitch = (
  walletKey: string,
  coinKey: string,
  defaultChecked: boolean
) => {
  const [loading, setLoading] = useState(false)
  const [checked, setChecked] = useState(defaultChecked)
  const onToggle = (value: boolean) => {
    setLoading(true)
    coinApi
      .toggleWalletCoin({
        accountKey: walletKey,
        coinKey,
        type: value ? 1 : 0,
      })
      .then(res => {
        if (res.success) {
          setChecked(value)
          emitter.emit(REFRESH_WALLET_DETAIL_EVENT)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return { loading, checked, onToggle }
}
